import { render, staticRenderFns } from "./ContestEntryFormLayout.vue?vue&type=template&id=8705f39c&scoped=true"
import script from "./ContestEntryFormLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContestEntryFormLayout.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContestEntryFormLayout.vue?vue&type=style&index=0&id=8705f39c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8705f39c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8705f39c')) {
      api.createRecord('8705f39c', component.options)
    } else {
      api.reload('8705f39c', component.options)
    }
    module.hot.accept("./ContestEntryFormLayout.vue?vue&type=template&id=8705f39c&scoped=true", function () {
      api.rerender('8705f39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/ContestEntryFormLayout.vue"
export default component.exports